"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MainFooter_1 = require("./MainFooter");
exports.default = MainFooter_1.default;
//# sourceMappingURL=index.js.map